import { Injectable } from '@angular/core'

import { Observable, of as observableOf } from 'rxjs'
import { LocalDate, LocalDateTime } from 'js-joda'

import { IInputCabinFaresGroup, IDatePeriod } from 'app/cabin-fares/cabin-fares-group/cabin-fares-group.component'
import { StepService } from '../shared/steps/step.service'
import { IFlowReservation } from '../shared/steps/step.model'
import { ICabinFares, Direction } from './cabin-fares.interfaces';

@Injectable()
export class CabinFaresMockService {

    private currency: string
    private reservation: IFlowReservation

    constructor(private stepService: StepService) {
        this.reservation = this.stepService.combineToReservation()
        this.currency = this.reservation.currencyCode
    }

    public initialize() {

    }

    public getCabinFaresDummyModel(): Observable<ICabinFares> {

        let model = <ICabinFares>
            {
                outbound: this.createDummyBackendModel(Direction.out),
                return: this.createDummyBackendModel(Direction.return),
                flowCabinFaresContent: { title: 'test title', moreThanOneCabinSelectedPopupTitle: '' }
            }
        return observableOf(model)
    }

    public getCabinFaresModel(): Observable<ICabinFares> {
        return this.getCabinFaresDummyModel()
    }

    public mergeContentfulAndSeabook() {

    }

    private loadCabinDetailsFromContentful(inputCabinFaresGroupFromBackend: IInputCabinFaresGroup): IInputCabinFaresGroup {
        return inputCabinFaresGroupFromBackend
    }

    private createDummyBackendModel(direction: Direction): IInputCabinFaresGroup {
        let inputCabinFaresGroup = <IInputCabinFaresGroup>{
            locale: 'da',
            departureDate: LocalDate.of(2020, 1, 1),
            routeDescription: direction === Direction.out ? 'København til Oslo' : 'Oslo til København',
            routeCode: direction === Direction.out ? 'CHOS' : 'OSCH',
            direction: direction,
            departures: [
                {
                    departureId: direction == Direction.out ? 'bda052d5' : 'c05cd680',
                    departureTime: LocalDateTime.of(2026, 1, 1, 19, 0),
                    ferryName: direction === Direction.out ? 'Crown Seaways' : 'Pearl Seaways',
                    cabinGroups: [
                        {
                            cabinGroupDescription: 'Standard',
                            cabinGroupCode: 'INSIDE',
                            inputCabinFaresSelectors: [
                                {
                                    cabinTypeCode: 'A1',
                                    genericId: null,
                                    direction: direction,
                                    description: 'generic cabin description 1',
                                    availableCapacity: 14,
                                    numberOfOccupiableBerths: 2,
                                    currency: this.currency,
                                    price: 1234,
                                    selectedQuantityOfCabin: 0,
                                    cabinDetailsFromContentful: null,
                                    numberOfSuggested: 0
                                },
                                {
                                    genericId: null,
                                    cabinTypeCode: 'AL',
                                    direction: direction,
                                    description: '2-personers kahyt med havudsigt, underkøjer',
                                    availableCapacity: 14,
                                    numberOfOccupiableBerths: 2,
                                    currency: this.currency,
                                    price: 324,
                                    selectedQuantityOfCabin: 0,
                                    cabinDetailsFromContentful: null,
                                    numberOfSuggested: 0
                                },
                                {
                                    genericId: null,
                                    cabinTypeCode: 'A5',
                                    direction: direction,
                                    description: '5-personers kahyt med havudsigt',
                                    availableCapacity: 14,
                                    numberOfOccupiableBerths: 5,
                                    currency: this.currency,
                                    price: 324,
                                    selectedQuantityOfCabin: 0,
                                    cabinDetailsFromContentful: null,
                                    numberOfSuggested: 0
                                },
                                {
                                    cabinTypeCode: 'B2',
                                    genericId: null,
                                    direction: direction,
                                    description: '2-bed inside cabin with bunk beds',
                                    numberOfOccupiableBerths: 2,
                                    currency: this.currency,
                                    price: 434,
                                    cabinDetailsFromContentful: null,
                                    numberOfSuggested: 0
                                }
                            ]
                        },
                        {
                            cabinGroupDescription: 'Premium',
                            cabinGroupCode: 'DELUXE',
                            inputCabinFaresSelectors: [
                                {
                                    genericId: null,
                                    cabinTypeCode: 'P3',
                                    direction: direction,
                                    description: '2-personers Commodore de Luxe, begrænset havudsigt, inkl. morgenmad',
                                    numberOfOccupiableBerths: 2,
                                    currency: this.currency,
                                    price: 5432,
                                    cabinDetailsFromContentful: null,
                                    numberOfSuggested: 0
                                },
                                {
                                    genericId: null,
                                    direction: direction,
                                    description: 'Premium Commodore Suite med jacuzzi på eget dekk',
                                    cabinTypeCode: 'J3',
                                    numberOfOccupiableBerths: 3,
                                    currency: this.currency,
                                    price: 9876,
                                    cabinDetailsFromContentful: null,
                                    numberOfSuggested: 0
                                },
                                {
                                    genericId: null,
                                    direction: direction,
                                    cabinTypeCode: 'J3',
                                    description: 'Premium Commodore Suite med jacuzzi på eget dekk',
                                    numberOfOccupiableBerths: 3,
                                    currency: this.currency,
                                    price: 4342,
                                    cabinDetailsFromContentful: null,
                                    numberOfSuggested: 0
                                }
                            ]
                        }
                    ]
                },
                {
                    departureId: direction == Direction.out ? 'fb4b2616' : 'bc2461b9',
                    departureTime: LocalDateTime.of(2026, 1, 1, 19, 0),
                    ferryName: direction === Direction.out ? 'Crown Seaways' : 'Pearl Seaways',
                    cabinGroups: [
                        {
                            cabinGroupDescription: 'Standard',
                            hasNewPopup: false,
                            cabinGroupCode: 'INSIDE',
                            inputCabinFaresSelectors: [
                                {
                                    cabinTypeCode: 'B2',
                                    genericId: null,
                                    direction: direction,
                                    description: '2-bed inside cabin with bunk beds',
                                    numberOfOccupiableBerths: 2,
                                    currency: this.currency,
                                    price: 434,
                                    cabinDetailsFromContentful: null,
                                    numberOfSuggested: 0
                                }
                            ]
                        }
                    ]
                }
            ]

        }

        return this.loadCabinDetailsFromContentful(inputCabinFaresGroup)
    }

}

